export const defaultRanges = [
  {
    title: 'Custom range',
    code: 'custom_range',
  },
]
